import React from "react";

/** Static pager shell — blog archive is single-page today; controls are non-interactive to avoid dead hash links. */
const BlogPagination = () => {
  return (
    <div className="pagination-wrap">
      <nav aria-label="Blog pages (preview)">
        <ul className="list-wrap">
          <li className="prv-next">
            <span className="opacity-50 cursor-not-allowed" title="Older posts — not wired yet" aria-hidden="true">
              <i className="fas fa-angle-double-left" />
            </span>
          </li>
          <li>
            <span className="current" title="Current page">
              1
            </span>
          </li>
          <li className="prv-right">
            <span className="opacity-50 cursor-not-allowed" title="Newer posts — not wired yet" aria-hidden="true">
              <i className="fas fa-angle-double-right" />
            </span>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default BlogPagination;
